import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import dayjs from 'dayjs';

const isDev = (process.env.NODE_ENV == 'development');

export default function SessionTracker({times, pageCount}) {
  const [appStartedAt, setAppStartedAt] = useState(dayjs())
  const [now, setNow] = useState(dayjs());

  useEffect(() => {
    window.setInterval(() => {
      setNow(dayjs());
    }, 1000);
  }, [])


  times = Array.isArray(times) ? times : [];

  let sessionStart = times[0] ? dayjs.unix(times[0]) : now;
  let renderedAt = times[1] ? dayjs.unix(times[1]) : now;
  let idleTime = times.length > 2 ? times[2] : 0;
  let sessionAge = times.length > 3 ? times[3] : 0;

  let millisOnPage = now ? now.diff(appStartedAt) : 0;

  // const seconds = Math.floor(date.getTime() / 1000);

  function open59() {
    window.Five9SocialWidget.maximizeChat({});
    console.log("OPEN 59")
    return false;
  }
  function click59() {
    $('#five9-maximize-button').click();
    console.log("CLICK 59")

    return false;
  }

  if (!isDev) return null;

  return null;

  // const [ startedAt, activeAt, age=0 ]
  return <div className="fixed bottom-8 right-0 bg-gray-200 p-2 text-xs leading-none opacity-50"
    style={{zIndex:9999}}>
    <div className="grid grid-cols-2 gap-0.5">
      <div>now</div>
      <div className="text-right">{now.format('HH:mm:ss')}</div>

      <div>seconds on page</div>
      <div className="text-right">{millisOnPage ? (millisOnPage / 1000).toFixed(2) : 0} s</div>

      <div>page loaded</div>
      <div className="text-right">{renderedAt.format('HH:mm:ss')}</div>

      <div>started</div>
      <div className="text-right">{sessionStart.format('HH:mm:ss')}</div>


      <div>previous page load</div>
      <div className="text-right">{idleTime} s</div>

      <div>session age</div>
      <div className="text-right">{sessionAge} s</div>


      <div>pageCount</div>
      <div className="text-right">{pageCount}</div>
    </div>

  </div>
}


